import { createAsyncAtom } from '../../lib';
import { getAccountService } from '../../services';
import { walletAddressAtom } from '../wallet';
import { activeAccountIdAtom } from './activeAccountIdAtom';

const activeAccountNameAtom = createAsyncAtom(async get => {
  const walletAddress = await get(walletAddressAtom);
  const activeAccountId = await get(activeAccountIdAtom);

  if (!walletAddress) {
    return null;
  }

  const accountService = getAccountService();

  return accountService.getActiveAccountName(walletAddress, activeAccountId);
});
export default activeAccountNameAtom;
